<template lang="pug">
figure.vrify-tile.relative
  .vrify-tile__image-container.relative.border.border-gray-200
    .coming-soon(v-if="props.isComingSoon")
      .coming-soon__content
        p Coming
        p Soon
    div(v-if="!props.imgSrc" :class="['vrify-tile__img', props.size ? `vrify-tile__img--${props.size}` : '']")
    img(v-else :class="['vrify-tile__img', props.size ? `vrify-tile__img--${props.size}` : '']" :src="props.imgSrc" alt="props.title")
    .gradient.absolute.h-full.w-full.top-0(v-if="$slots.toggle")
    .absolute.right-0.bottom-0.mr-3.mb-3
      slot(name="badge")
  slot(name="toggle")
  figcaption.vrify-tile__content
    .vrify-tile__subtitle
      slot(name="subtitle")
    h5 {{ props.title }}
    .vrify-tile__date
      slot(name="date")
</template>

<script lang="ts" setup>
const props = defineProps({
  size: {
    type: String,
    default: 'small',
  },
  title: {
    type: String,
    required: true,
  },
  imgSrc: {
    type: String,
    default: null,
  },
  isComingSoon: {
    type: [String, Boolean],
    default: false,
  },
})
</script>

<style lang="stylus" scoped>
.gradient
  background: linear-gradient(-135deg, rgba(224, 224, 224, 0.5) 0%, rgba(224, 224, 224, 0) 20%)

.vrify-tile
  &__image-container
    border-radius: 0.25rem
    .coming-soon
      @apply absolute flex justify-center items-center w-full h-full text-white text-xl flex-col
      background: rgba(0, 0, 0, 0.35)

  &__img
    @apply rounded w-full object-cover cursor-pointer
    height: 220px

  &__content
    h5
      @apply text-xl text-black mb-0 capitalize text-ellipsis overflow-hidden whitespace-nowrap mt-1 font-medium

  &__subtitle
    @apply text-gray-850 block uppercase pt-1 text-sm mt-2

  &__date
    @apply text-gray-850 block uppercase pt-1 text-sm capitalize

@screen xl1
  .vrify-tile__date
    &__subtitle, &__date
      font-size: .85rem

    &__content
      h5
        font-size: 1.2rem

@screen xl1
  .vrify-tile__date
    &__img--small
      height: 150px
</style>
